var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "g-display-list-filtering__item g-display-list-filtering__per-page",
    },
    [
      _c("fieldset", [
        _c("legend", { staticClass: "u-hide-visually" }, [
          _vm._v("Number of Products to Show"),
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "g-form-list" }, [
          _c("li", { staticClass: "g-form-list__item" }, [
            _c("div", { staticClass: "g-form-label" }, [_vm._v("View")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "g-display-list-per-page__options" },
              _vm._l(_vm.perPage, function (option) {
                return _c(
                  "label",
                  {
                    key: option.value,
                    staticClass: "g-display-list-per-page__option",
                    attrs: { title: `Show ${option.label} per page` },
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedPerPage,
                          expression: "selectedPerPage",
                        },
                      ],
                      staticClass: "g-form-checkbox__input",
                      attrs: { type: "radio" },
                      domProps: {
                        value: option.value,
                        checked: _vm._q(_vm.selectedPerPage, option.value),
                      },
                      on: {
                        change: function ($event) {
                          _vm.selectedPerPage = option.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "g-display-list-per-page__caption" },
                      [_vm._v(_vm._s(option.label))]
                    ),
                  ]
                )
              }),
              0
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }